import React from 'react';
import { Activity, DollarSign, Unlock, Zap } from 'lucide-react';

const features = [
  {
    icon: Activity,
    title: 'Full Traces',
    description: 'Every tool call, input, output, and duration. Know exactly what happened.',
  },
  {
    icon: DollarSign,
    title: 'Cost Tracking',
    description: 'Real-time cost per run, reported directly from Claude SDK.',
  },
  {
    icon: Unlock,
    title: 'Open Spec',
    description: 'Self-host with our reference receiver, or use our platform. No lock-in.',
  },
  {
    icon: Zap,
    title: 'Zero Config',
    description: 'Works out of the box. Console output locally, HTTP when you\'re ready.',
  },
];

const FeaturesSection = () => {
  return (
    <section id="features" className="py-20 px-6 bg-muted/30">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight">
            Everything you need to <span className="text-blue-600 dark:text-blue-400">observe</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Drop-in observability with zero configuration. Start simple, scale when ready.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="group p-8 rounded-xl bg-card border border-border hover:shadow-xl hover:border-blue-500/30 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-lg bg-blue-500/10 flex items-center justify-center mb-4 group-hover:bg-blue-500/20 transition-colors">
                <feature.icon className="h-6 w-6 text-blue-600 dark:text-blue-400" />
              </div>
              <h3 className="text-2xl font-bold mb-3">{feature.title}</h3>
              <p className="text-base text-muted-foreground">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;